import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function upgradeAccountReducer(state = initialState.upgradeAccountForm, action) {
    switch (action.type) {
        case types.UPGRADE_TO_TICKETING_ACCOUNT_SUCCESS:
            return {
                ...state,
                isUpgradeSuccessful: true,
                accountUpgradeMessages: action.accountUpgradeMessages,
            };
        case types.UPGRADE_TO_TICKETING_ACCOUNT_ERROR:
            return {
                ...state,
                isUpgradeSuccessful: false,
                accountUpgradeMessages: action.accountUpgradeMessages
            };
        case types.LOAD_UPGRADE_TO_ONE_CLUB_FORM_DATA_SUCCESS:
            return {
                ...state,
                isUpgradeToOneClubFormDataLoadedSuccessful: true,
                upgradeToOneClubFormData: action.ssoUpgradeToOneClubFormData
            };
        case types.LOAD_UPGRADE_TO_ONE_CLUB_FORM_DATA_ERROR:
            return {
                ...state,
                isUpgradeToOneClubFormDataLoadedSuccessful: false,
                upgradeToOneClubFormData: {}
            };
        case types.RESET_UPGRADE_ACCOUNT_FORM:
            return initialState.upgradeAccountForm;
        default:
            return state;
    }
}
